import create from '@verndale/core';
import modules, { global } from './modules';

let modulesCreated = false;

document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return;
  modulesCreated = true;

  global();
  create(modules);
});
